import {NgModule} from '@angular/core';
import {Footer2Component} from "../layout/footer2/footer2.component";
import {Footer3Component} from "../layout/footer3/footer3.component";
import {PortalHeaderComponent} from "../obligor-search/portal-header/portal-header.component";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatFormFieldModule} from "@angular/material/form-field";
import {CommonModule} from "@angular/common";
import {RouterLink} from "@angular/router";
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {AbsPipe} from './abs.pipe';
import {SearchPanelComponent} from "./search-panel/search-panel.component";
import {MatInputModule} from "@angular/material/input";
import {MatTabsModule} from "@angular/material/tabs";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {RecentSearchesComponent} from "./search-panel/recent-searches/recent-searches.component";
import {RecentlyReportsComponent} from "./search-panel/recently-reports/recently-reports.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport, ScrollingModule} from "@angular/cdk/scrolling";
import {MatListModule} from "@angular/material/list";
import {
  CachedFilesMenuItemComponent
} from "../obligor-search/portal-header/cached-files-menu-item/cached-files-menu-item.component";


@NgModule({
  declarations: [
    SearchPanelComponent,
    Footer2Component,
    Footer3Component,
    PortalHeaderComponent,
    CachedFilesMenuItemComponent,
    ConfirmationDialogComponent,
    RecentSearchesComponent,
    RecentlyReportsComponent,
    AbsPipe
  ],
  imports: [
    MatAutocompleteModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatFormFieldModule,
    CommonModule,
    RouterLink,
    MatInputModule,
    MatTabsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    CdkVirtualScrollViewport,
    MatListModule,
    CdkFixedSizeVirtualScroll,
    ScrollingModule
  ],
  exports: [
    Footer2Component,
    Footer3Component,
    PortalHeaderComponent,
    MatMenuModule,
    AbsPipe,
    SearchPanelComponent,
    RecentSearchesComponent,
    RecentlyReportsComponent
  ]
})
export class SharedModule {
}
